var healthQuestionsResponse = require('./health-questions.json');
export default healthQuestionsResponse;
